export default ['人脸照片', '身份证正面','身份证背面','储蓄卡','信用卡'];



// WEBPACK FOOTER //
// ./src/service/constant/ocrType.js